
import { Component, inject, input, output, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TemplateController } from '@domain';
import { RaButtonComponent, RaInputComponent } from '@shared/components';
import { RaCheckboxComponent } from 'src/app/shared/components/ra-checkbox/ra-checkbox.component';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'modal-create-template',
    templateUrl: 'modal-create-template.component.html',
    styleUrl: 'modal-create-template.component.scss',
    imports: [
        RaModalComponent,
        RaInputComponent,
        RaButtonComponent,
        ReactiveFormsModule,
        RaCheckboxComponent,
        TranslatePipe,
    ],
})
export class ModalCreateTemplateComponent {
    @ViewChild(RaModalComponent) modal!: RaModalComponent;
    public documentId = input.required<string>();
    public close = output<void>();
    public loading = signal(false);
    public formGroup = new FormGroup({
        title: new FormControl('', [Validators.required, Validators.minLength(3)]),
        sessions: new FormControl({ value: true, disabled: true }, []),
        allFieldsNeedSave: new FormControl(false),
    });

    // * [Injects]
    private _utilService = inject(UtilService);
    private _templateController = inject(TemplateController);

    /**
     * Cancela a criação do template e fecha o modal
     */
    public onCancel(): void {
        if (this.loading()) return;

        this.modal?.handleClose();
    }

    /**
     * Cria um template
     */
    public createTemplate(): void {
        if (!this._utilService.isFormValid(this.formGroup)) return;

        const title = this.formGroup.get('title')?.value;
        const allFieldsNeedSave = this.formGroup.get('allFieldsNeedSave')?.value;

        this.loading.set(true);

        this._templateController
            .insertByDocument(this.documentId(), title, allFieldsNeedSave)
            .subscribe({
                next: () => {
                    this.loading.set(false);

                    this.onCancel();
                },
                error: () => this.loading.set(false),
            });
    }
}
